/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable  react-perf/jsx-no-new-function-as-prop */
import React from 'react'

import { getMintPrice, normalizePrice } from '@common/functions'
import { SVGChevronLeft, SVGChevronRight } from '@common/public/assets'
import CheckerDate from '@components/CheckerDate'
import Ticket from '@components/Ticket'
import useMain from '@hooks/useMain'
import useNetwork from '@hooks/useNetwork'
import { IEndPoint } from '@types'

import {
    BagdgeContainer,
    CaroulselTitle,
    CaroulselTitleContainer,
    Container,
    ContainerImage,
    ContainerTag,
    ContainerText,
    ContainerTextDesc,
    ContainerTextFooter,
    ContainerTexts,
    ContainerTextTitle,
    CustomCarousel,
    CustomCarouselCounterWrapper,
    CustomCarouselCounterWrapperText,
} from './styles'

const SalesBehaviourCarousel: React.FC = () => {
    /* This function will generate a array with the number of subarray we specif */
    const [currentMintPrices, setCurrentMintPrices] = React.useState<string[]>([])

    const {
        state: {
            config,
            mainInit: { network, blockchain, salesBehavior },
        },
        operations: { setCurrentSelectedEndpoint, setContractSalesPhase, setCurrentStep },
    } = useMain()

    const {
        state: { totalSupply },
    } = useNetwork()
    function createGroups(array: IEndPoint[], numberGroups: number) {
        const chunks = []
        const n = array.length
        let index = 0

        while (index < n) {
            chunks.push(array.slice(index, (index += numberGroups)))
        }
        return chunks
    }
    const [currentIndex, setCurrentIndex] = React.useState(0)
    const numberOfGroupsPerRow = 3
    const EndpointsCarousel = createGroups(salesBehavior, numberOfGroupsPerRow)

    const setSalesBehaviour = (endpoint: IEndPoint) => {
        setContractSalesPhase(endpoint.position)
        setCurrentSelectedEndpoint(endpoint)
    }
    const handleClick = (action: 'next' | 'prev') => {
        if (action === 'next' && currentIndex < EndpointsCarousel.length - 1) {
            setCurrentIndex(currentIndex + 1)
        }
        if (action === 'prev' && currentIndex > 0) {
            setCurrentIndex(currentIndex - 1)
        }
    }

    const handleCurrentMintPriceChange = (endpoint: IEndPoint, index: number) => {
        const price = getMintPrice(endpoint.mintPrice, endpoint.startDate, endpoint.dutchAuction)
        setCurrentMintPrices(oldValue => {
            const currentMintPricesCopy = [...oldValue]
            currentMintPricesCopy[index] = normalizePrice(price, 1)
            return currentMintPricesCopy
        })
    }

    React.useEffect(() => {
        setCurrentStep('home-multiple-sales-behaviour')
        const temporaryCurrentMintPrices = salesBehavior.map(endpoint => {
            const price = getMintPrice(endpoint.mintPrice, endpoint.startDate, endpoint.dutchAuction)
            return normalizePrice(price, 1)
        })
        setCurrentMintPrices(temporaryCurrentMintPrices)
    }, [])

    return (
        <>
            <CaroulselTitleContainer>
                <CaroulselTitle>Minting is live</CaroulselTitle>
            </CaroulselTitleContainer>
            <CustomCarousel>
                {EndpointsCarousel[currentIndex].map((endpoint, index) => (
                    <Container key={`${index}-${currentIndex}`} onClick={() => setSalesBehaviour(endpoint)}>
                        <ContainerTag>
                            <BagdgeContainer>
                                <span id="bagdge-container">
                                    {endpoint.hasWhiteList ? (
                                        <span
                                            id={`bagdge-container-private-${index}`}
                                            className="bagdge-container-private"
                                        >
                                            Private Sales
                                        </span>
                                    ) : (
                                        <span
                                            id={`bagdge-container-public-${index}`}
                                            className="bagdge-container-public"
                                        >
                                            Public Sales
                                        </span>
                                    )}
                                </span>
                            </BagdgeContainer>
                            <CheckerDate
                                id="Sales behavior timer"
                                startDate={endpoint.startDate}
                                dutchAuction={endpoint.dutchAuction}
                                reverseColor={true}
                                handleCurrentMintPriceChange={() =>
                                    handleCurrentMintPriceChange(endpoint, index + numberOfGroupsPerRow * currentIndex)
                                }
                            />
                        </ContainerTag>
                        <ContainerImage>
                            <Ticket assetUrl={endpoint.assetUrl} />
                        </ContainerImage>
                        <ContainerTexts>
                            <ContainerText>
                                <ContainerTextTitle id={`sales-behavior-title-${index}`}>
                                    {endpoint.title}
                                </ContainerTextTitle>
                                <ContainerTextDesc id={`sales-behavior-description-${index}`}>
                                    {endpoint.description}
                                </ContainerTextDesc>
                            </ContainerText>
                            <ContainerTextFooter>
                                <span>
                                    <span id={`sales-behavior-total-supply${index}`}>{totalSupply}</span> NFTs
                                </span>

                                <span id={`sales-behavior-price-${index}`}>{`${
                                    currentMintPrices[index + numberOfGroupsPerRow * currentIndex]
                                } ${config.networks[network][blockchain].currency}`}</span>
                            </ContainerTextFooter>
                        </ContainerTexts>
                    </Container>
                ))}
            </CustomCarousel>
            {EndpointsCarousel.length > 1 && (
                <CustomCarouselCounterWrapper
                    is_last_index={currentIndex === EndpointsCarousel.length - 1}
                    is_index_0={currentIndex === 0}
                >
                    <span
                        onClick={() => {
                            handleClick('prev')
                        }}
                        className="carousel-control-prev-icon"
                    >
                        <SVGChevronLeft />
                    </span>
                    {EndpointsCarousel.map((_, index) => (
                        <CustomCarouselCounterWrapperText
                            isSelected={index === currentIndex}
                            onClick={() => setCurrentIndex(index)}
                            key={index}
                        >
                            {index + 1}
                        </CustomCarouselCounterWrapperText>
                    ))}
                    <span
                        onClick={() => {
                            handleClick('next')
                        }}
                        className="carousel-control-next-icon"
                    >
                        <SVGChevronRight />
                    </span>
                </CustomCarouselCounterWrapper>
            )}
        </>
    )
}

export default SalesBehaviourCarousel
